
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Build from 'plaid-threads/Icons/Build';
import Key from 'plaid-threads/Icons/Key';
import Mobile from 'plaid-threads/Icons/Mobile';
import Rocket from 'plaid-threads/Icons/Rocket';
import Sandbox from 'plaid-threads/Icons/Sandbox';
import Transfer from 'plaid-threads/Icons/Transfer';
import Actions from '../../../components/docs/Actions';
import Layout from '../../../components/docs/Layout';
import Image from '../../../components/docs/Image';
import Video from '../../../components/accelerate/Video';
import Bio from '../../../components/accelerate/Bio';
export const metadata = {
  noIndex: true,
  title: 'Your Accelerate Guide',
  section: 'Accelerate',
  toc: false,
  description: 'Your Accelerate Guide'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    {/* Accelerate Components */}


    <Header title='Program Overview' subtitle='The resources available to you.' mdxType="Header" />
    <h6 {...{
      "id": "why-did-we-create-accelerate"
    }}>{`Why did we create Accelerate?`}</h6>
    <p>{`Entrepreneurship should be accessible. Anyone with a great idea should have
access to the same opportunities and resources to be successful. Plaid believes
in technology as a force for good. We want to unlock financial freedom for
everyone by empowering entrepreneurs and innovators. To do that, we hope to
achieve more inclusivity and equitable access to financial services.`}</p>
    <p>{`We know that there is still a significant disparity in access, especially at
the earliest and most crucial stages of company development. Our goal is to
help power a financial system that works for everyone, and we recognize that
one way to further that goal is by supporting and promoting a diverse ecosystem
of entrepreneurs.`}</p>
    <Layout.Spacer units={5} />
    <h6 {...{
      "id": "focus-areas"
    }}>{`Focus areas`}</h6>
    <p>{`We designed Accelerate to support early-stage BIPOC founders by offering resources
to launch businesses with 3 core focus areas:`}</p>
    <ol>
      <li parentName="ol">{`Providing resources to accelerate growth`}</li>
      <li parentName="ol">{`Making it easier to access capital and services`}</li>
      <li parentName="ol">{`Offering ongoing mentorship and support`}</li>
    </ol>
    <Layout.Spacer units={5} />
    <h4 {...{
      "id": "providing-resources-to-accelerate-growth"
    }}>{`Providing resources to accelerate growth`}</h4>
    <p>{`The Plaid Accelerate program kicks off with a 4 day virtual bootcamp consisting of
15 workshops on relevant technical, product, and business topics to help guide
early business development.`}</p>
    <p>{`We will upload bootcamp workshop materials and resources from subsequent
workshops throughout the program to the `}<a parentName="p" {...{
        "href": "https://plaid.highspot.com/items/61f440bc91b282eb28708ad8?lfrm=shp.0"
      }}>{`Plaid Accelerate HighSpot
page`}</a>{` for
you and your team to reference.`}</p>
    <p>{`Read more about `}<a parentName="p" {...{
        "href": "/accelerate/2022/workshops"
      }}>{`workshops and resources`}</a></p>
    <Layout.Spacer units={4} />
    <h4 {...{
      "id": "making-it-easier-access-to-capital-and-services"
    }}>{`Making it easier access to capital and services`}</h4>
    <p>{`Plaid has built a network of supportive partners from VCs to service providers
that power the fintech ecosystem to make it easier to build your business.`}</p>
    <p>{`Read more about the `}<a parentName="p" {...{
        "href": "/accelerate/2022/network"
      }}>{`Plaid Accelerate Network`}</a>{` programming
and how you can utilize our partners.`}</p>
    <h4 {...{
      "id": "ongoing-support"
    }}>{`Ongoing support`}</h4>
    <p>{`We designed the five month program with a founder’s schedule in mind. After the
initial bootcamp, you can expect programming to range from 5-10 hours per month
all depending on how much you participate in available sessions. While we
encourage you to utilize the full range of ongoing support systems available to
you, we do not mandate participation. Take advantage of what works for you and
spend the rest of the time building your company.`}</p>
    <p>{`Read more about our `}<a parentName="p" {...{
        "href": "/accelerate/2022/ongoing-support"
      }}>{`ongoing support systems`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "providing-resources-to-accelerate-growth",
        level: 4,
        title: "Providing resources to accelerate growth",
      },
{
        id: "making-it-easier-access-to-capital-and-services",
        level: 4,
        title: "Making it easier access to capital and services",
      },
{
        id: "ongoing-support",
        level: 4,
        title: "Ongoing support",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
